import {
  setCookieRefreshTokenServerAction,
  setCookieTokenServerAction
} from '../../actions/set-cookie';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../config';

type TokenKey = typeof ACCESS_TOKEN_KEY | typeof REFRESH_TOKEN_KEY

export const setToken = async (token: string, key: TokenKey): Promise<void> => {
  // const isServer = typeof window === 'undefined';
  // if (isServer) return; // access token in the server can only be put through auth-middleware.ts
  // localStorage.setItem(key, token);
  if (key === 'access_token') {
    await setCookieTokenServerAction(token);
  }
  if (key === 'refresh_token') {
    await setCookieRefreshTokenServerAction(token);
  }
};

export const getToken = async (key: TokenKey): Promise<string | null> => {
  const isServer = typeof window === 'undefined';
  let token = '';
  if (isServer) {
    const { cookies } = await import('next/headers');
    token = (await cookies()).get(key)?.value || '';
  } else {
    token =
      typeof localStorage === 'object' ? localStorage.getItem(key) || '' : '';
  }
  return token;
};
